<template>
  <div class="home admin-home">
    <header class="home-header admin-header">
      <div class="header-wrap">
        <router-link to="/">
          <img
            class="logo"
            src="./../assets/header/logo.png"
            alt="沐桦科技"
          />
        </router-link> 
        <div class="email">{{email}}</div>
        <div
          class="quit"
          @click="clickLogout"
        >退出</div>
      </div>
    </header>
    <section class="content">
      <!-- <el-col
        :span="4"
        class="left-menu"
      > -->
      <div class="left-menu">
        <div class="left-content">
          <div class="menu-wrap">
            <div class="title">泛载雾计算</div>
            <el-menu
              default-active="1-1"
              class="el-menu-vertical-demo"
              background-color="#243032"
              text-color="#fff"
              active-text-color="#00AEEF"
              router="router"
              :default-openeds="defaultOption"
            >
              <!-- <el-menu-item
                index="1"
                width="180px"
                route="/admin"
              >
                <span slot="title">高质量动态代理</span>
              </el-menu-item> -->
              <el-submenu
                index="1"
                route="/admin"
              >
                <template slot="title">
                  <span>高质量动态代理</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item route="/admin" v-bind:class="{ isActive: (thisPath === '/admin') }">数据概览</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <el-submenu
                index="2"
                route="/ccd"
              >
                <template slot="title">
                  <span>CCD</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item route="/ccd" v-bind:class="{ isActive: (thisPath === '/ccd') }">数据概览</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <!-- <el-submenu index="2">
                <template slot="title">
                  <span>边缘计算</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="2-1">PCDN</el-menu-item>
                </el-menu-item-group>
              </el-submenu> -->
              <el-menu-item
                index="3"
                disabled
              >
                <span slot="title">分布式存储</span>
              </el-menu-item>
              <el-menu-item
                index="3"
                disabled
              >
                <span slot="title">数据通道</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>
      <div class="right-content admin-right-wrap">
        <div class="service-choose">
          <h1 class="title">高质量动态代理</h1>
          <el-select
            v-model="serviceName"
            placeholder="请选择"
            size="mini"
            class="select"
            @change="changeService"
          >
            <el-option
              v-for="item in serviceList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <!-- <div class="times"><i class="el-icon-warning"></i> 状态更新频率为 15分钟/次</div> -->
        <div class="service-wrap common-wrap">
          <h1 class="title">我的服务</h1>
          <div class="secret-Detail">
            <div class="serviceDetail">
              <div class="service-title">KEY</div>
              <div class="service-content">
                <span
                  v-if="key"
                  class="service-big-content"
                >{{key}}</span>
                <span
                  v-if="!key"
                  class="service-big-content"
                >-</span>
              </div>
            </div>
            <div class="serviceDetail">
              <div class="service-title">密钥</div>
              <div
                v-if="secret"
                class="service-content"
              ><span class="service-big-content">{{secret}}</span></div>
              <div
                v-if="!secret"
                class="service-content"
              ><span class="service-big-content">-</span></div>
            </div>
            <div class="serviceDetail">
              <div class="service-title">线路总数</div>
              <div
                class="service-content"
                v-if="lineCount"
              >
                <span class="service-big-content">{{lineCount}}</span>
                条</div>
              <div
                class="service-big-content"
                v-if="!lineCount"
              >-</div>
            </div>
            <div class="serviceDetail">
              <div class="service-title">IP端口</div>
              <div
                class="service-content"
                v-if="ports.length === 0"
              ><span class="service-big-content showIps">-</span></div>
              <div
                class="service-content"
                v-if="ports.length === 1"
              ><span class="service-big-content showIps">{{ports[0].ip[0]}}: {{ports[0].port}}-{{ ports[0].port + ports[0].port_num }}</span></div>
              <div
                class="service-content"
                v-if="ports.length > 1"
                @click="open"
              ><span class="service-big-content showIps">查看</span></div>
            </div>
          </div>
        </div>
        <div class="common-wrap">
          <h1 class="title">切换日志</h1>
          <div class="">
            <span class="demonstration">日期</span>
            <el-date-picker
              v-model="selectDate"
              type="date"
              size="smail"
              placeholder="选择日期"
            >
            </el-date-picker>
            <div
              class="button search-button bonus-cursor"
              v-on:click="searchLogs"
            >查询</div>
          </div>
          <div class="log-detail">
            <el-table
              :data="serviceLogs"
              border
            >
              <el-table-column
                prop="time"
                label="时间"
              >
              </el-table-column>
              <el-table-column
                prop="request"
                label="切换数量"
              >
              </el-table-column>
              <el-table-column
                prop="success"
                label="成功数量"
              >
              </el-table-column>
              <el-table-column
                prop="error"
                label="失败数量"
              >
              </el-table-column>
            </el-table>
          </div>

          <el-pagination
            v-if="total >= 20"
            background
            layout="prev, pager, next"
            :page-size="20"
            :pager-count="11"
            :total="total"
            class="pagination"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
          >
          </el-pagination>
        </div>
        <div class="common-wrap rate-wrap">
          <h1 class="title">宽带详情</h1>
          <div class="">
            <span class="demonstration">日期</span>
            <el-date-picker
              v-model="selectRateDate"
              type="date"
              size="smail"
              placeholder="选择日期"
            >
            </el-date-picker>
            <div
              class="button search-button bonus-cursor"
              v-on:click="searchDayRate"
            >查询</div>
          </div>
          <div class="log-detail">
            <ve-line v-if="serviceRate.rows && serviceRate.rows.length" :data="serviceRate" :settings="chartSetting"></ve-line>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";
import moment from "moment";

export default {
  name: "home",
  components: {
    Footer,
    Menu
  },
  data() {
    return {
      activeIndex: "1",
      selectDate: moment().startOf("day"),
      offset: 0,
      limit: 20,
      currentPage: 1,
      serviceName: "",
      selectRateDate: moment().startOf("day"),
      serviceRate: [],
      chartSetting: {
        yAxisName: ['单位：Mbps']
      }
    };
  },
  computed: mapState({
    key: state => state.user.key,
    secret: state => state.user.secret,
    service: state => state.service,
    serviceLogs: state => state.service.serviceLogs,
    total: state => state.service.total,
    lineCount: state => state.service.lineCount,
    ports: state => state.service.ports,
    serviceList: state => state.service.serviceList,
    email: state => state.user.email,
    thisPath () {
      return this.$route.path
    },
    defaultOption () {
        return ['1']
    },
  }),

  created() {
    let that = this;

    // 获取用户信息
    this.getUserInfo();
    // 获取service列表
    this.getServiceList().then(serviceName => {
      let { selectDate } = that;
      let date_after = moment(selectDate).valueOf();
      let date_before = date_after + 24 * 60 * 60 * 1000 - 1;

      // 获取service日志
      this.getProfileList({
        service: serviceName,
        date_before,
        date_after,
        offset: 0,
        limit: 20
      });
      this.serviceName = serviceName;

      this.searchRate({
        service: serviceName,
        date_before,
        date_after,
      });
    });
  },
  methods: {
    ...mapActions([
      "getUserInfo",
      "getServiceList",
      "getProfileList",
      "logout",
      "getRate"
    ]),
    
    // 分页处理
    handleCurrentChange(value) {
      let queryDate = this.selectDate;
      let offset = (value - 1) * 20;
      let limit = 20;
      let { serviceName } = this;
      let date_after = moment(queryDate).valueOf();
      let date_before = date_after + 24 * 60 * 60 * 1000 - 1;

      this.getProfileList({
        service: serviceName,
        offset,
        limit,
        date_after,
        date_before
      });
    },
    // change service
    changeService(value) {
      this.serviceName = value;
      let { selectDate } = this;
      let offset = 0,
        limit = 20;
      let date_after = moment(selectDate).valueOf();
      let date_before = date_after + 24 * 60 * 60 * 1000 - 1;

      this.getServiceList({ serviceName: value });
      this.getProfileList({
        service: value,
        date_before,
        date_after,
        offset,
        limit
      });
    },
    // 日志查询
    searchLogs() {
      let { serviceName, selectDate, offset, limit } = this;
      let date_after = moment(selectDate).valueOf();
      let date_before = date_after + 24 * 60 * 60 * 1000 - 1;

      // 获取service日志
      this.getProfileList({
        service: serviceName,
        date_before,
        date_after,
        offset,
        limit
      });
    },
    // 查询某日费率
    searchDayRate() {
      let { serviceName, selectRateDate } = this;
      let date_after = moment(selectRateDate).valueOf();
      let date_before = date_after + 24 * 60 * 60 * 1000 - 1;

      this.searchRate({
        date_after,
        date_before,
        service: serviceName
      });
    },
    // 费率查询
    searchRate(data) {
      let that = this;

      // 获取service日志
      this.getRate(data).then(res => {
        // 此处为了中英文对照，所以动态处理
          let useBandCharts = {
            columns: ['日期', '出带宽', '入带宽'],
            rows: []
          };

          res.map(item => {
            let date_at = moment(item.time_in_utc).format("YYYY-MM-DD HH:mm:ss");
            useBandCharts.rows.push({
              '日期': date_at, 
              '出带宽': item.outbps / 1000000, 
              '入带宽': item.inbps / 1000000
            })
          });
          that.serviceRate = useBandCharts;
      });
    },

    open() {
      let ports = this.ports;
      let portDetail = "";
      ports.map(item => {
        let endPort = item.port + item.port_num - 1;
        portDetail = portDetail + item.ip + " " + item.port + "-" + endPort;
      });

      this.$alert("IP端口", "IP端口", {
        confirmButtonText: "确定",
        callback: action => {
          this.$message({
            type: "info",
            message: `${portDetail}`
          });
        }
      });
    },
    // 注销
    clickLogout() {
      this.logout();
    }
  }
};
</script>

<style lang="stylus">
.admin-home .home-header {
  height: 60px;
  background: #FFFFFF;
  margin: 0 auto;
  position: relative;
  margin-left: 17px;
  width: 100%;
  position: fixed;
  top: 0;
  margin-left: 0px;
  padding-left: 17px;
  max-width: 100%;
  z-index: 1000;
  .header-wrap {
    width: 100%;
    position: relative;
  }
  .email {
    position: absolute;
    right: 10i 0px;
    height: 62px;
    font-size: 14px;
    color: #fff;
    line-height: 62px;
    margin-left: 50px;
    color: #282f3c;
    display: inline-block;
    top: 0;
    right: 100px;
  }
  .quit {
    position: absolute;
    right: 48px;
    height: 62px;
    font-size: 14px;
    color: #fff;
    line-height: 62px;
    margin-left: 50px;
    color: #282f3c;
    display: inline-block;
    top: 0;
  }
}

.logo {
  width: 126px;
  height: 40px;
  margin: 10px 0;
}

.user-content {
  width: 100%;
  background: rgba(20, 31, 33, 1);
}

.home {
  height: 100%;
}

.left-menu {
  background: #1C2628;
  height: 100%;
  position: fixed;
  top: 60px;
  left: 0px;
}

.admin-home .content {
  height: 100%;
  overflow: auto;
  zoom: 1;
  background: black;
  margin-top: 60px;
}

.content .right-content.admin-right-wrap {
  background: #F8FBFB;
  min-height: 100%;
  padding: 0 48px;
  margin-left: 180px;
  padding-bottom: 30px;
  .title {
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(89, 114, 119, 1);
    line-height: 24px;
    margin: 32px 0 24px;
  }
  .times {
    background: rgba(115, 210, 245, 0.1);
    border-radius: 2px;
    border: 1px solid rgba(115, 210, 245, 1);
    padding: 6px;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(0, 174, 239, 1);
    line-height: 20px;
  }
  .common-wrap {
    background: rgba(248, 251, 251, 1);
    padding: 16px 24px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(231, 232, 233, 1);
    margin: 0 0 24px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(89, 114, 119, 1);
    line-height: 18px;
    .title {
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      color: rgba(36, 48, 50, 1);
      line-height: 24px;
      margin: 0 0 32px;
    }
  }
  .rate-wrap{
    margin-bottom: 20px;
  }

  .key-secret-wrap {
    .key, .secret {
      line-height: 30px;
    }
    .title {
      margin: 0 0 20px;
    }
  }

  .secret-Detail {
    display: flex;
    .serviceDetail {
      width: 25%;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(89, 114, 119, 1);
      line-height: 18px;
      .service-title {
        margin-bottom: 16px;
      }
      .service-big-content {
        font-size: 20px;
        font-family: Arial-BoldMT;
        font-weight: normal;
        color: rgba(76, 125, 135, 1);
        line-height: 48px;
      }
      .showIps {
        font-size: 16px;
      }
      .service-tips {
        font-size: 12px;
      }
    }
  }
}

.demonstration {
  margin-right: 20px;
}

.right-content .service-wrap {
  padding-bottom: 32px;
  .service-tips {
    margin-top: 12px;
  }
}

.right-content {
  .service-select {
    display: flex;
    .title {
      margin-right: 20px;
    }
  }
}

.service-choose {
  display: flex;
  .select {
    line-height: 24px;
    margin: 32px 0 24px 20px;
  }
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #00AEEF !important;
  color: #fff;
}

.pagination {
  text-align: right;
  margin: 20px 0 20px;
}

.menu-wrap {
  height: 100%;
  background: black;
  .title {
    font-size: 18px;
    font-family: PingFangSC-Light;
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
    line-height: 56px;
    font-size: 18px;
    color: #fff;
    width: 180px;
    display: inline-block;
    text-aligh: center;
    height: 56px;
    padding-left: 20px;
  }
}

.isActive{
  color: #00AEEF !important
}
</style>
